import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchTicketRead, fetchTickets } from "../../redux/tickets.ts";
import { Pagination } from "../../components/pagination/index.js";
import { isEmpty } from "../../helper/join.js";
import { Table } from "../../components/table/index.jsx";
import { Breadcrumbs } from "../../components/breadcrumbs/index.jsx";
import { Modal } from "../../components/modal/index.jsx";

export const AllTickets = () => {
	const dispatch = useDispatch();
	const { ticketList, isLoading } = useSelector((store) => store.ticket);
	const [id, setId] = useState(null);
	const [showOthers, setShowOthers] = useState(false);
	const [ticketMessages, setTicketMessages] = useState([]);
	const [selectedTicket, setSelectedTicket] = useState(null);
	const ticketsData = ticketList?.tickets || ticketList;

	useEffect(() => {
		if (isEmpty(ticketList)) {
			dispatch(fetchTickets(1));
		}
	}, []);

	function handlePage(page) {
		dispatch(fetchTickets(page));
	}

	const handleRead = (id) => {
		setId(id);
		dispatch(fetchTicketRead(id))
	};

	const handleViewOthers = (_, __, tab) => {
		if (!tab?.others?.length) {
			return;
		}
		setSelectedTicket(tab);
		setTicketMessages(tab.others);
		setShowOthers(true);
	};

	const tableData = [
		{ value: "user_name", to: "" },
		{ key: "Ticket Type", value: "ticket_type" },
		{ key: "Email", value: "user_email" },
		{ key: "Description", value: "description" },
		{ key: "Reason", value: "reason" },
		{ key: "Date Created", value: "created_at", type: "date" },
	];

	const actions = [
	{ type: "read", func: handleRead, isLoading: isLoading?.ticketRead },
	{ type: "view", func: handleViewOthers },
	{ type: "email", to: 'user_email', subject:'ticket_type' }];

	return (
		<>
			<Breadcrumbs breadcrumbs={[
					{name: 'Tickets', link: ''},
			]} />
			<div className="lg:mx-10 mx-3 relative">
				<div className="lg:h-[calc(100vh-190px)] overflow-auto my-2 hide-scroll">
					<Table
						data={tableData}
						table={ticketsData}
						actions={actions}
						id={id}
						isLoading={isLoading?.tickets}
					/>
				</div>
				<Pagination
					current={ticketsData?.current_page}
					func={handlePage}
					total={ticketsData?.last_page}
				/>
			</div>
			<Modal size={"lg"} show={showOthers} setShow={setShowOthers}>
				<div className="px-1">
					<h3 className="text-xl font-semibold mb-1">Ticket Conversation</h3>
					<p className="text-sm text-gray-500 mb-4">
						Ticket #{selectedTicket?.id} - {selectedTicket?.user_email || "N/A"}
					</p>
					{ticketMessages?.length ? (
						<div className="max-h-[60vh] overflow-y-auto flex flex-col gap-y-3 pr-1">
							{ticketMessages.map((item, index) => (
								<div key={item?.client_id || index} className="border rounded-md p-3">
									{item?.role || item?.message ? (
										<>
											<div className="text-xs uppercase font-semibold text-gray-500 mb-1">
												{item?.role || "unknown"}
											</div>
											<p className="text-sm break-words">{item?.message || "-"}</p>
										</>
									) : (
										<div className="grid grid-cols-1 md:grid-cols-2 gap-3">
											{Object.entries(item || {}).map(([key, value]) => (
												<div key={key}>
													<p className="text-xs uppercase text-gray-500">{key.replaceAll("_", " ")}</p>
													<p className="text-sm break-words">{value || "-"}</p>
												</div>
											))}
										</div>
									)}
								</div>
							))}
						</div>
					) : (
						<div className="text-sm text-gray-500">No conversation available.</div>
					)}
				</div>
			</Modal>
		</>
	);
};
